import { GlobalContextData, GetGlobalContext } from '../classes/context';
import { useContext, useEffect, useState } from 'react';
import * as WS from '../webServices/cyMyManager'
import '../classes/styles/style.css';
import Screen from '../components/screen';
import ActionBtn from '../components/actionBtn';
import { deletePromozione, getDatiAziendaDaPIva } from '../webServices/cyMyManagerPlus';
import Modal from '../components/modal';
import TablePromo from '../mobile-components/tablePromo';

export default function Promozioni() {
    const globalContext = useContext<GlobalContextData>(GetGlobalContext);
    const [modalShow, setModalShow] = useState(false)
    const [abbonamenti, setAbbonamenti] = useState<WS.Plus.IF.Abbonamento[] | undefined>(undefined);
    const [promozioni, setPromozioni] = useState<WS.Plus.IF.Promozione[] | undefined>(undefined);
    const [promoSel, setPromoSel] = useState<WS.Plus.IF.Promozione | undefined>(undefined);
    const [sedi, setSedi] = useState<WS.Plus.IF.SedeEsercente[] | undefined>(undefined);
    const [dataDaSel, setDataDaSel] = useState<string | undefined>(undefined);
    const [dataASel, setDataASel] = useState<string | undefined>(undefined);
    const [promoChk, setPromoChk] = useState<number[]>([]);
    const [alertWrap, setAlertWrap] = useState<string>('alert-wrap');
    const [filSedeSel, setFilSedeSel] = useState<string | undefined>(undefined)
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    // Form Promozione
    const [sedeSel, setSedeSel] = useState<string>("")
    const [codPromo, setCodPromo] = useState<string>("");
    const [desPromo, setDesPromo] = useState<string>("");
    const [scontoPromo, setScontoPromo] = useState<number>(0);
    const [abbSel, setAbbSel] = useState<string>("");

    const viewOperOK = () => {
        setModalShow(false)
        setAlertWrap('alert-wrap alert-show');

        setTimeout(() => {
            setAlertWrap('alert-wrap');
        }, 3000)
    }

    const onMultipleDelete = async () => {
        for (let i = 0; i < promoChk.length; i++) {
            await deletePromozione(WS.UT.TOKEN, promoChk[i])
        }

        await updateListaPromo()

        setPromoChk([]);

        viewOperOK();
    }

    const clearForm = () => {
        setPromoSel({ ...WS.Plus.IF.PromozioneInit(), tipoPromo: WS.Plus.IF.TipoPromo.Abbonamento, TipoApplicaz: WS.Plus.IF.TipoApplicPromo.Sconto, Descrizioni: [{ ...WS.Plus.IF.PromozioneDescrInit(), IdLingua: 1, Descrizione: '' }] });
        setSedeSel("");
        setCodPromo("");
        setDesPromo("");
        setAbbSel("");
        setDataASel('');
        setDataDaSel('');
        setScontoPromo(0);
    }

    const updateListaPromo = async () => {
        let listPromo = await WS.Plus.getListaPromozioni(WS.UT.TOKEN, parseInt(filSedeSel ?? '0'));

        if (listPromo.isOk)
            setPromozioni(listPromo.list);

        clearForm();
    }

    const updateListaAbb = async () => {
        let listAbb = await WS.Plus.getListaAbbonamentiFull(WS.UT.TOKEN, "", 0, -1, -1, 0, 0, -1, 0, 0, parseInt(filSedeSel ?? '0') ?? 0);
        if (listAbb.isOk)
            setAbbonamenti(listAbb.list);
    }


    const updatePromozioni = async (body: WS.Plus.IF.Promozione): Promise<WS.Plus.IF.GenericResponse> => {

        body.CodicePromo = codPromo;
        body.Descrizioni[0].Descrizione = desPromo;
        body.ScontoUnitario = scontoPromo;
        body.IdSedeEserc = parseInt(sedeSel);
        body.Abbonamento.Id = parseInt(abbSel);
        body.DataDa = dataDaSel ?? '';
        body.DataA = dataASel ?? '';

        if (isNaN(body.IdSedeEserc) || body.IdSedeEserc == 0)
            return WS.Plus.IF.GenericErrorResponse("Sede non indicata!")

        if (body.CodicePromo == '')
            return WS.Plus.IF.GenericErrorResponse("Codice promo non indicato!")

        if (body.Descrizioni[0].Descrizione == '')
            return WS.Plus.IF.GenericErrorResponse("Descrizione non indicata!")

        if (isNaN(body.ScontoUnitario) || body.ScontoUnitario <= 0 || body.ScontoUnitario > 100)
            return WS.Plus.IF.GenericErrorResponse("Sconto non valido!")

        if (body.Abbonamento.Id == 0)
            return WS.Plus.IF.GenericErrorResponse("Abbonamento non valido!")

        let res = await WS.Plus.updatePromozione(WS.UT.TOKEN, body)

        await updateListaPromo()

        if (res.isOk)
            viewOperOK()

        return res;
    }

    const deletePromo = async (idPromozione: number) => {
        let res = await WS.Plus.deletePromozione(WS.UT.TOKEN, idPromozione)

        await updateListaPromo()

        if (res.isOk)
            viewOperOK()
        else
            window.alert(res.msgErr)

        return res;
    }

    const passToModal = (promozione: WS.Plus.IF.Promozione) => {
        setSedeSel(promozione.sedeEserc.Id.toString())
        setCodPromo(promozione.CodicePromo)
        setDesPromo(promozione.Descrizioni[0].Descrizione)
        setScontoPromo(promozione.ScontoUnitario)
        setAbbSel(promozione.Abbonamento.Id.toString())
        setDataDaSel(promozione.DataDa)
        setDataASel(promozione.DataA)

        setPromoSel(promozione)
        setModalShow(true);
    }

    const onLoad = async (): Promise<void> => {
        // await updateListaPromo()

        let listSedi = await WS.Plus.getListaSediEsercenti(WS.UT.TOKEN, "", globalContext.vars.esercente?.Id ?? 0, 0, 0, 0, 0);

        if (listSedi.isOk) {
            setSedi(listSedi.list);
            setFilSedeSel(listSedi.list[0].Id.toString())
        }
    };


    const checkAllAbb = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            const tuttiId = promozioni?.map((promo) => promo.Id) || [];
            setPromoChk(tuttiId);
        } else {
            setPromoChk([]);
        }
    };

    const handleCheck = (id: number) => {
        if (promoChk.includes(id)) {
            setPromoChk(promoChk.filter((selezionatoId) => selezionatoId !== id));
        } else {
            setPromoChk([...promoChk, id]);
        }
    };



    const modalBody = (): JSX.Element =>
        <>
            <div className='row'>
                <div className='col-12 mb-3'>
                    <label htmlFor="sedeEse">Sede</label>
                    <select name="sedEse" className='form-select' value={sedeSel} onChange={(s) => setSedeSel(s.target.value)}>
                        <option value="">Seleziona Sede</option>
                        {sedi ?
                            sedi.map((sede, s) =>
                                <option key={s} value={sede.Id}>{sede.Indirizzo}</option>
                            )
                            :
                            undefined
                        }
                    </select>
                </div>
                <div className='col-12 col-md-6 mb-3'>
                    <label htmlFor="codPromo">Codice Promo</label>
                    <input className="form-control " type="text" placeholder="Inserisci codice promozione" value={codPromo} onChange={(n) => setCodPromo(n.target.value)} />
                </div>
                <div className='col-12 col-md-6 mb-3'>
                    <label htmlFor="desPromo">Descrizione Promo</label>
                    <input className="form-control " type="text" placeholder="Inserisci descrizione promozione" value={desPromo} onChange={(n) => setDesPromo(n.target.value)} />
                </div>
                <div className='col-12 col-md-6 mb-3'>
                    <label htmlFor="scontoPromo">Sconto %</label>
                    <input className="form-control" type="number" placeholder="" value={scontoPromo} onChange={(num) => setScontoPromo(parseInt(num.target.value))} />
                </div>
                <div className='col-12 col-md-6 mb-3'>
                    <label htmlFor="selAbb">Abbonamento</label>
                    <select name='selAbb' className='form-select' value={abbSel} onChange={(s) => setAbbSel(s.target.value)}>
                        <option value="">Seleziona abbonamento</option>
                        {abbonamenti ?
                            abbonamenti.map((abb, s) =>
                                <option key={s} value={abb.Id}>{abb.Nome}</option>
                            )
                            :
                            undefined
                        }
                    </select>
                </div>
                <div className='col-12 col-md-6 mb-3'>
                    <label htmlFor="dataDa">Data Da</label>
                    <input className="form-control" type="date" placeholder=""value={dataDaSel} onChange={(num) => setDataDaSel(num.target.value)} />
                </div>
                <div className='col-12 col-md-6 mb-3'>
                    <label htmlFor="dataA">Data A</label>
                    <input className="form-control" type="date" placeholder="" value={dataASel} onChange={(num) => setDataASel(num.target.value)} />
                </div>
            </div>
        </>

    useEffect(() => {
        onLoad();
    }, []);

    useEffect(() => {
        if (filSedeSel !== undefined) {
            updateListaAbb()
            updateListaPromo()
        }

    }, [filSedeSel])

    return (
        <Screen>
            <div className='container'>
                <div className={alertWrap}>
                    <div className="alert alert-primary" role="alert">Operazione Effettuata!</div>
                </div>
                <div className='row'>
                    <div className='d-flex flex-column flex-md-row card mb-3'>
                        <h2>Promozioni</h2>
                        <div className='ms-auto'>
                            <ActionBtn
                                modello='Promozioni'
                                add={true}
                                del={true}
                                onDel={onMultipleDelete}
                                modalOnSave={() => updatePromozioni(promoSel ?? WS.Plus.IF.PromozioneInit())}
                                modalOnClose={() => clearForm()}
                                modalBody={modalBody()}
                                onNew={clearForm}
                                sedi={sedi}
                                sedeSel={filSedeSel}
                                setSedeSel={setFilSedeSel}
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 card'>
                        <table className="table">
                            <thead>
                                {isMobile ?
                                    <></>
                                    :
                                    <tr>
                                    <th scope='col'>
                                        <input className="form-check-input" type="checkbox" onChange={checkAllAbb} checked={promozioni && promoChk.length === promozioni.length} />
                                    </th>
                                    <th scope="col">#</th>
                                    <th scope="col">Codice Promo</th>
                                    <th scope="col">Descrizione</th>
                                    <th scope="col">Data Inizio</th>
                                    <th scope="col">Data Fine</th>
                                </tr>
                                }

                            </thead>
                            <tbody>
                                {promozioni ?
                                    promozioni.map((promo, index) =>
                                        isMobile ?
                                        <TablePromo promo={promo} passToModal={() => passToModal(promo)} />
                                        :
                                        <tr className='pointer' key={index} >
                                            <td scope="row" style={{ width: '55px' }}>
                                                <input className="form-check-input" type="checkbox" checked={promoChk.includes(promo.Id)} onChange={() => handleCheck(promo.Id)} />
                                            </td>
                                            <td onClick={() => passToModal(promo)}>{promo.Id}</td>
                                            <td onClick={() => passToModal(promo)}>{promo.CodicePromo}</td>
                                            <td onClick={() => passToModal(promo)}>{promo.Descrizioni[0].Descrizione}</td>
                                            <td onClick={() => passToModal(promo)}>{new Date(promo.DataDa ?? '').toLocaleDateString('it-IT', {day: '2-digit', month: '2-digit', year: 'numeric'})}</td>
                                            <td onClick={() => passToModal(promo)}>{new Date(promo.DataA ?? '').toLocaleDateString('it-IT', {day: '2-digit', month: '2-digit', year: 'numeric'})}</td>
                                        </tr>
                                    )
                                    :
                                    undefined
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <Modal
                isShow={modalShow}
                onClose={() => setModalShow(false)}
                onDel={async () => {
                    if (promoSel?.Id)
                        await deletePromo(promoSel?.Id);
                }}
                title=""
                body={
                    modalBody()
                }
                onSave={() => updatePromozioni(promoSel ?? WS.Plus.IF.PromozioneInit())}
            />
        </Screen>
    );
}

